import { ArrowsUpDownIcon, ArrowTrendingUpIcon, CurrencyDollarIcon, Square3Stack3DIcon } from "@heroicons/react/24/outline";

const getCardDataByType = (type) => {
    switch (type) {
        case "cash": {
            return {
                borderClass: "border-green-300",
                backgroundColorClass: "bg-green-50",
                iconWrapperClass: "bg-green-200",
                iconColorClass: "text-green-700",
                titleClass: "text-green-700",
                priceClass: "text-green-900",
                borderClassCompare: "bg-green-700",
                percentageRatioClass: null,
                percentageClass: "bg-green-600 text-white",
                CardPercentageIcon: ArrowTrendingUpIcon,
                CardIcon: CurrencyDollarIcon,
            }
        }
        case "inventory": {
            return {
                borderClass: "border-amber-300",
                backgroundColorClass: "bg-amber-50",
                iconWrapperClass: "bg-amber-200",
                iconColorClass: "text-amber-700",
                borderClassCompare: "bg-amber-700",
                titleClass: "text-amber-700",
                priceClass: "text-amber-900",
                percentageRatioClass: null,
                percentageClass: "bg-amber-600 text-white",
                CardPercentageIcon: ArrowTrendingUpIcon,
                CardIcon: Square3Stack3DIcon,
            }
        }
        case "capital": {
            return {
                borderClass: "border-blue-300",
                backgroundColorClass: "bg-blue-50",
                iconWrapperClass: "bg-blue-200",
                iconColorClass: "text-blue-700",
                borderClassCompare: "bg-blue-700",
                titleClass: "text-blue-700",
                priceClass: "text-blue-900",
                percentageRatioClass: "text-blue-600",
                percentageClass: "bg-blue-600 text-white",
                CardPercentageIcon: ArrowTrendingUpIcon,
                CardIcon: ArrowsUpDownIcon,
            }
        }
        case "current-ratio": {
            return {
                borderClass: "border-indigo-300",
                backgroundColorClass: "bg-indigo-50",
                iconWrapperClass: "bg-indigo-200",
                iconColorClass: "text-indigo-700",
                borderClassCompare: "bg-indigo-700",
                titleClass: "text-indigo-700",
                priceClass: "text-indigo-900",
                percentageRatioClass: null,
                percentageClass: "bg-indigo-600 text-white",
                CardPercentageIcon: null,
                CardIcon: ArrowTrendingUpIcon,
            }
        }
        case "quick-ratio": {
            return {
                borderClass: "border-teal-300",
                backgroundColorClass: "bg-teal-50",
                iconWrapperClass: "bg-teal-200",
                iconColorClass: "text-teal-700",
                borderClassCompare: "bg-teal-700",
                titleClass: "text-teal-700",
                priceClass: "text-teal-900",
                percentageRatioClass: null,
                percentageClass: "bg-teal-600 text-white",
                CardPercentageIcon: null,
                CardIcon: ArrowTrendingUpIcon,
            }
        }
        case "profit": {
            return {
                borderClass: "border-rose-300",
                backgroundColorClass: "bg-rose-50",
                iconWrapperClass: "bg-rose-200",
                iconColorClass: "text-rose-700",
                borderClassCompare: "bg-rose-700",
                titleClass: "text-rose-700",
                priceClass: "text-rose-900",
                percentageRatioClass: null,
                percentageClass: "bg-rose-600 text-white",
                CardPercentageIcon: null,
                CardIcon: CurrencyDollarIcon,
            }
        }
        default:
            return {
                borderClass: "border-green-200",
                backgroundColorClass: "bg-green-50",
                iconWrapperClass: "bg-green-100",
                iconColorClass: "text-green-600",
                borderClassCompare: "bg-green-700",
                titleClass: "text-green-700",
                priceClass: "text-green-900",
                percentageRatioClass: "text-green-600",
                percentageClass: "bg-green-600 text-white",
                CardPercentageIcon: null,
                CardIcon: null,
            }
    }
}

export const BalanceSheetCard = ({
    type,
    cardTitle,
    cardPrice,
    comparePrice,
    compareLabel,
    comparePercentage,
    cardPercentageRatio,
    cardPercentage,
}) => {

    const cardByType = getCardDataByType(type);
    const CardIcon = cardByType?.CardIcon;
    const CardPercentageIcon = cardByType?.CardPercentageIcon;

    return (
        <article className={`flex-1 rounded-lg border-2 shadow-md transition-all duration-200 hover:shadow-lg ${cardByType?.borderClass || ""} ${cardByType?.backgroundColorClass || ""}`}>
            <div className="p-4">
                <div className="flex items-start justify-between gap-4">
                    <div className="flex-1 flex flex-col gap-2">
                        {cardTitle && (
                            <p className={`text-sm font-semibold uppercase tracking-wide ${cardByType?.titleClass || ""}`}>
                                {cardTitle}
                            </p>
                        )}
                        <div className="flex flex-row gap-2">
                            {cardPrice && (
                                <p className={`text-2xl font-bold ${cardByType?.priceClass || ""}`}>
                                    {cardPrice}
                                </p>
                            )}
                            {cardPercentageRatio && (
                                <p className={`text-sm font-medium ${cardByType?.percentageRatioClass || ""}`}>
                                    Ratio: {cardPercentageRatio}
                                </p>
                            )}
                            {cardPercentage && (
                                <div className="flex items-center gap-2">
                                    <div className={`flex flex-row gap-1 items-center rounded-full font-semibold transition-colors text-xs px-3 py-0.5 ${cardByType?.percentageClass || ""}`}>
                                        {CardPercentageIcon && <CardPercentageIcon className="h-4 w-4" />}
                                        <span>
                                            {cardPercentage}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                        {comparePrice ? (
                            <div className="mt-1">
                                <div className={`h-0.5 w-full rounded ${cardByType?.borderClassCompare}`} />
                                <div className="flex-1 flex flex-col gap-2 mt-2">
                                    <div className="font-semibold tabular-nums">
                                        {compareLabel ? (
                                            <div className="font-semibold tabular-nums">
                                                <span className={`text-sm font-bold ${cardByType?.priceClass}`}>{compareLabel}</span>
                                            </div>
                                        ) : null}
                                        <div className="flex flex-row gap-2">
                                            <span className={`text-2xl font-bold ${cardByType?.priceClass}`}>{comparePrice}</span>
                                            {comparePercentage ? (
                                                <div className={`flex w-fit self-center flex-row gap-1 items-center rounded-full font-semibold transition-colors text-xs px-3 py-0.5 ${cardByType?.percentageClass || ""}`}>
                                                    <span>{comparePercentage}</span>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                    <div className={`rounded-full p-1.5 ${cardByType?.iconWrapperClass || ""}`}>
                        {CardIcon && <CardIcon className={`h-7 w-7 ${cardByType?.iconColorClass || ""}`} />}
                    </div>
                </div>
            </div>
        </article>
    )
}